
import React from "react";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <main className="flex-grow pt-28 pb-16">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="text-3xl font-bold text-[#0c4a6e] mb-8">Términos y Condiciones</h1>
          
          <div className="prose prose-blue max-w-none">
            <p className="mb-4">
              Última actualización: {new Date().toLocaleDateString('es-ES', {year: 'numeric', month: 'long', day: 'numeric'})}
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">1. Aceptación de los Términos</h2>
            <p className="mb-4">
              Al acceder o utilizar el sitio web de Gavinsurance, usted acepta estar sujeto a estos Términos y Condiciones. Si no está de acuerdo con alguna parte de estos términos, no podrá acceder al sitio web.
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">2. Uso del Sitio</h2>
            <p className="mb-4">
              Usted acepta utilizar nuestro sitio web sólo para fines legales y de una manera que no infrinja los derechos de otros o restrinja su uso del sitio.
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">3. Precisión de la Información</h2>
            <p className="mb-4">
              Nos esforzamos por proporcionar información precisa y actualizada, pero no garantizamos la exactitud, integridad o actualidad de la información disponible en nuestro sitio web.
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">4. Propiedad Intelectual</h2>
            <p className="mb-4">
              Todo el contenido de este sitio web, incluyendo textos, gráficos, logotipos, imágenes y software, está protegido por derechos de autor y otras leyes de propiedad intelectual.
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">5. Limitación de Responsabilidad</h2>
            <p className="mb-4">
              En ningún caso Gavinsurance, sus directores, empleados o agentes serán responsables por cualquier daño directo, indirecto, incidental, especial o consecuente derivado del uso o la imposibilidad de uso del sitio.
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">6. Modificaciones</h2>
            <p className="mb-4">
              Nos reservamos el derecho de modificar estos términos en cualquier momento. Le recomendamos revisar periódicamente esta página para estar al tanto de cualquier cambio.
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">7. Ley Aplicable</h2>
            <p className="mb-4">
              Estos términos se regirán e interpretarán de acuerdo con las leyes del estado de Florida, sin tener en cuenta sus disposiciones de conflicto de leyes.
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">8. Contacto</h2>
            <p className="mb-4">
              Si tiene alguna pregunta sobre estos términos, por favor contáctenos en:
            </p>
            <p className="mb-4">
              <strong>Email:</strong> <a href="mailto:info@gavinsurance.com" className="text-[#0284c7] hover:underline">info@gavinsurance.com</a><br />
              <strong>Teléfono:</strong> <a href="tel:+17865695142" className="text-[#0284c7] hover:underline">(888) 370-8454</a><br />
              <strong>Dirección:</strong> 7500 NW 25 ST #237, Doral, FL 33122
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
